import Auth from '@/pages/Auth';
import { FullLoading } from '@components/Loaders';
import { createLazyFileRoute } from '@tanstack/react-router';
import React from 'react';
import { useTranslation } from 'react-i18next';

function AuthPending() {
  const { t } = useTranslation('auth');
  return <FullLoading label={t('saml.loading_settings')} />;
}

export const Route = createLazyFileRoute('/auth/')({
  component: () => <Auth />,
  pendingComponent: AuthPending,
});
